import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import computer from 'assets/images/Tools-survey-cap60.jpeg';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const FEATURE_DATA = [
  {
    id: '01',
    title: 'Customizable questions.',
  },
  {
    id: '02',
    title: 'Comments boxes.',
  },
  {
    id: '03',
    title: 'Drop down menus.',
  },
];
function CustomSurvey() {
  return (
    <div>
      <Helmet>
        <title>Custom Survey - CAP60</title>
        <meta
          name="description"
          content="Create your own surveys in minutes with CAP60's custom survey tool, and integrate them into your client kiosks! Contact us Right Away!."
        />
        <meta name="keyword" content="custom survey" />
      </Helmet>
      <PageBanner
        title="Custom Surveys"
        // subtitle="The state kiosk is an access portal that can generate reports from existing data in agency databases."
      />
      <ClienDesk />
      <div className="floralbg-blue">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
            itemClass={styles.featureItem}
          />
        </Container>
      </div>
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>
                Don’t guess what your clients think. Ask them! It’s a simple
                tool that pays great dividends.
              </h2>
            </div>
            <p>
              With the CAP60 Custom Survey tool create your own surveys in
              minutes and integrate them into your client kiosk. With
              customizable display formats and unique answer logic you can get
              the answers and information easy as 1-2-3.
            </p>

            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image src={computer} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CustomSurvey;
